/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Button = (function () {

    function Button () {

        Monet.UI.Fields.Base.apply (this, arguments);

        this.createBaseStructure = function(){
            this.createRootElement();
            this.createElement();
        };

        this.validate = function() {};

        this.createElement = function () {
            this.input = document.createElement('input');
            this.input.type = 'button';
        };

        this.getValue = function () {
            if(this.input){
                this.value = this.input.value;
            }
            return this.value;
        };

        this.setValue = function (value) {
            this.value = value;
            if(this.input){
                this.input.value = value;
            }
        };

        this.removeClickEventListener = function (customJavaScript){
            if(!customJavaScript && this.meta) {
                customJavaScript = this.meta.customJavascript;
            }
            this.removeEventListener('click', customJavaScript);
        };

        this.addEventClickListener = function (customJavaScript){
            if(!customJavaScript && this.meta) {
                customJavaScript = this.meta.customJavascript;
            }
            this.addEventListener('click', customJavaScript);
        };

        this.removeEventListener = function (event, customJavaScript){

            var action = customJavaScript;

            if (typeof action === 'string') {
                action = new Function( customJavaScript );
            }

            this.input.removeEventListener(event, action);
        };

        this.addEventListener = function (event,customJavaScript){

            var action = customJavaScript;

            if (typeof action === 'string') {
                action = new Function( customJavaScript );
            }

            this.input.addEventListener(event, action);
        };

        this.render = function () {

            this.rootEl = this.input;
            this.setValue(this.value);
            return this.rootEl;
        };

        this.toggleLoadingInBtn = function() {
            
            const element = this.input;
            if (element.classList) {
                element.disabled = !element.classList.contains("loader-spinner") ? true : false;
                element.classList.toggle("loader-spinner");
            } else {
                element.disabled = !element.disabled;
            }
        }

        this.createBaseStructure();
    }

    return Button;

}());